// Extracted to @heidi/workspace — history:
// `git log --follow src/features/migrations/hooks/useMigrateTranscriptDefaultTabToNote.ts`.
//
// The write is INJECTED rather than taken from `@heidi/workspace/data`'s
// same-named `useMutateUpdateUser`: only the app delegate performs the three app
// reactions it sequences, and design D7 bans putting them on the
// `configureWorkspaceData` seam.
import { SessionTabType } from '@heidi/schema/ml-scribe';
import { useEffect } from 'react';

export interface MigrateTranscriptDefaultTabPorts {
  /** The saved `session_settings.default_new_session_tab`, undefined until the user resolves. */
  defaultSessionTab: SessionTabType | undefined;
  /** Performs the user-record write, with whatever app reactions the caller owns. */
  updateUser: (payload: {
    session_settings: { default_new_session_tab: SessionTabType };
  }) => Promise<unknown>;
}

/*
 * Used to move users off of transcript tab default new tab setting
 * https://linear.app/getheidi/issue/SCR-568/prevent-access-to-transcript-tab-before-session-starts
 */
export const useMigrateTranscriptDefaultTabToNote = ({
  defaultSessionTab,
  updateUser,
}: MigrateTranscriptDefaultTabPorts) => {
  useEffect(() => {
    if (defaultSessionTab === SessionTabType.TRANSCRIPT) {
      void updateUser({
        session_settings: { default_new_session_tab: SessionTabType.NOTE },
      });
    }
  }, [defaultSessionTab, updateUser]);
};
